/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_my_two_missions_today = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui, je dédie mon expertise à deux missions : <strong class="text-current">construire des solutions digitales</strong> qui transforment des business, et <strong class="text-current">former la prochaine génération</strong> de créateurs de valeur via l'Academy.`)
};

const en_my_two_missions_today = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today, I dedicate my expertise to two missions: <strong class="text-current">building digital solutions</strong> that transform businesses, and <strong class="text-current">training the next generation</strong> of value creators through the Academy.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const my_two_missions_today = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.my_two_missions_today(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("my_two_missions_today", locale)
	if (locale === "fr") return fr_my_two_missions_today(inputs)
	return en_my_two_missions_today(inputs)
};